import styled from 'styled-components';
import Container from 'components/Container';
import LoadingOverlay from 'components/LoadingOverlay';
import { sizes } from 'style';

export const HomeContainer = styled.div`
  overflow-x: hidden;
`;

export const SectionContainer = styled(Container)`
  padding-top: 1px;
  min-height: initial;

  @media ${sizes.desktop} {
    padding-right: 80px;
    padding-left: 80px;
  }
`;

export const SectionsLoading = styled.div.attrs({
  children: <LoadingOverlay isLoading variant="darkFull" />
})`
  position: relative;
  min-height: 100svh;
`;
